module.exports = __webpack_public_path__ + "img/agency2_logo.d7713cd6.png";